export default "__VITE_ASSET__BP_LuH9m__"